import "whatwg-fetch";
import LinearProgress from "@material-ui/core/LinearProgress";

const TableCellPayoutData = ({ prop, value }) => {
  if (!value || value.fetching) return <LinearProgress mode="indeterminate" />;
  else if (value.data) {
    if (prop == "ssn")
      return <div className="table-cell-money">{value.data.SSN}</div>;
    if (prop == "bankName")
      return (
        <div className="table-cell-money">{value.data.BankNumber.BankName}</div>
      );
    if (prop == "bankNumber")
      return (
        <div className="table-cell-money">{value.data.BankNumber.Number}</div>
      );
    if (prop == "fee")
      return (
        <div className="table-cell-money">
          {value.data.InitFee ? value.data.InitFee.Amount : 0}
        </div>
      );
    if (prop == "sum") {
      let init = value.data.InitFee ? value.data.InitFee.Amount : 0;
      let val = value.data.PayoutAmount.Amount + init;
      return <div className="table-cell-money">{val}</div>;
    }
  } else {
    return null;
  }
};

export default TableCellPayoutData;
